// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3yUtp","header":"PatientQuestionnaire_header__3t4BS","info":"PatientQuestionnaire_info__9sPn2"};